/* tslint:disable */
/* eslint-disable */
/**
 * KGH PROJECT API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateNewPostCommand } from '../models';
// @ts-ignore
import { GroupOverviewDto } from '../models';
// @ts-ignore
import { PostDto } from '../models';
/**
 * NewsfeedApi - axios parameter creator
 * @export
 */
export const NewsfeedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [onlySentByMe] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewsfeedGet: async (pageSize?: number, pageNumber?: number, onlySentByMe?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Newsfeed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (onlySentByMe !== undefined) {
                localVarQueryParameter['OnlySentByMe'] = onlySentByMe;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewsfeedIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiNewsfeedIdDelete', 'id', id)
            const localVarPath = `/api/Newsfeed/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewsfeedMyAudienceGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Newsfeed/my-audience`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateNewPostCommand} [createNewPostCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewsfeedPost: async (createNewPostCommand?: CreateNewPostCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Newsfeed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNewPostCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsfeedApi - functional programming interface
 * @export
 */
export const NewsfeedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NewsfeedApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [onlySentByMe] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewsfeedGet(pageSize?: number, pageNumber?: number, onlySentByMe?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PostDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewsfeedGet(pageSize, pageNumber, onlySentByMe, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewsfeedIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewsfeedIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewsfeedMyAudienceGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewsfeedMyAudienceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateNewPostCommand} [createNewPostCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewsfeedPost(createNewPostCommand?: CreateNewPostCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewsfeedPost(createNewPostCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NewsfeedApi - factory interface
 * @export
 */
export const NewsfeedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NewsfeedApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageSize] 
         * @param {number} [pageNumber] 
         * @param {boolean} [onlySentByMe] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewsfeedGet(pageSize?: number, pageNumber?: number, onlySentByMe?: boolean, options?: any): AxiosPromise<Array<PostDto>> {
            return localVarFp.apiNewsfeedGet(pageSize, pageNumber, onlySentByMe, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewsfeedIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiNewsfeedIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewsfeedMyAudienceGet(options?: any): AxiosPromise<Array<GroupOverviewDto>> {
            return localVarFp.apiNewsfeedMyAudienceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateNewPostCommand} [createNewPostCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewsfeedPost(createNewPostCommand?: CreateNewPostCommand, options?: any): AxiosPromise<string> {
            return localVarFp.apiNewsfeedPost(createNewPostCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiNewsfeedGet operation in NewsfeedApi.
 * @export
 * @interface NewsfeedApiApiNewsfeedGetRequest
 */
export interface NewsfeedApiApiNewsfeedGetRequest {
    /**
     * 
     * @type {number}
     * @memberof NewsfeedApiApiNewsfeedGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {number}
     * @memberof NewsfeedApiApiNewsfeedGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {boolean}
     * @memberof NewsfeedApiApiNewsfeedGet
     */
    readonly onlySentByMe?: boolean
}

/**
 * Request parameters for apiNewsfeedIdDelete operation in NewsfeedApi.
 * @export
 * @interface NewsfeedApiApiNewsfeedIdDeleteRequest
 */
export interface NewsfeedApiApiNewsfeedIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsfeedApiApiNewsfeedIdDelete
     */
    readonly id: string
}

/**
 * Request parameters for apiNewsfeedPost operation in NewsfeedApi.
 * @export
 * @interface NewsfeedApiApiNewsfeedPostRequest
 */
export interface NewsfeedApiApiNewsfeedPostRequest {
    /**
     * 
     * @type {CreateNewPostCommand}
     * @memberof NewsfeedApiApiNewsfeedPost
     */
    readonly createNewPostCommand?: CreateNewPostCommand
}

/**
 * NewsfeedApi - object-oriented interface
 * @export
 * @class NewsfeedApi
 * @extends {BaseAPI}
 */
export class NewsfeedApi extends BaseAPI {
    /**
     * 
     * @param {NewsfeedApiApiNewsfeedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsfeedApi
     */
    public apiNewsfeedGet(requestParameters: NewsfeedApiApiNewsfeedGetRequest = {}, options?: AxiosRequestConfig) {
        return NewsfeedApiFp(this.configuration).apiNewsfeedGet(requestParameters.pageSize, requestParameters.pageNumber, requestParameters.onlySentByMe, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NewsfeedApiApiNewsfeedIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsfeedApi
     */
    public apiNewsfeedIdDelete(requestParameters: NewsfeedApiApiNewsfeedIdDeleteRequest, options?: AxiosRequestConfig) {
        return NewsfeedApiFp(this.configuration).apiNewsfeedIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsfeedApi
     */
    public apiNewsfeedMyAudienceGet(options?: AxiosRequestConfig) {
        return NewsfeedApiFp(this.configuration).apiNewsfeedMyAudienceGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NewsfeedApiApiNewsfeedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsfeedApi
     */
    public apiNewsfeedPost(requestParameters: NewsfeedApiApiNewsfeedPostRequest = {}, options?: AxiosRequestConfig) {
        return NewsfeedApiFp(this.configuration).apiNewsfeedPost(requestParameters.createNewPostCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
